import filter from 'lodash/filter';
import { GET_PRODUCT_TEACHERS_SUCCESS } from '../teacher-roll/actions';
import * as actions from './actions';

const initState = {
    teachers: [],
    isTeachersLoaded: false,
    authToken: '',
    teacherJWTToken: '',
    isGettingToken: false
};

const getUpdatedTeachers = (teachers) => {
    const filteredTeachers = filter(teachers, teacher => teacher.assignedClassrooms.length);

    const teachersList = filteredTeachers.map(teacher => ({
        name: `${teacher.lastName}, ${teacher.firstName}`,
        id: teacher.userProfileId,
        assignedClassrooms: teacher.assignedClassrooms,
        password: teacher.password,
        userName: teacher.userName
    }));
    return teachersList;
};

export default function (state = initState, action) {
    switch (action.type) {
    case GET_PRODUCT_TEACHERS_SUCCESS: {
        return {
            ...state,
            teachers: getUpdatedTeachers(action.data),
            isTeachersLoaded: true
        };
    }

    case actions.GET_TEACHER_AUTH_TOKEN_REQUEST: {
        return {
            ...state,
            authToken: '',
            teacherJWTToken: '',
            isGettingToken: action.isGettingToken
        };
    }

    case actions.GET_TEACHER_AUTH_TOKEN_SUCCESS: {
        return {
            ...state,
            authToken: action.authToken,
            teacherJWTToken: action.jwt,
            isGettingToken: action.isGettingToken
        };
    }

    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/teacher-view/reducer.js